<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="SVGRepo_bgCarrier"
            stroke-width="0"></g>
        <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
            <path
                d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                :stroke="color"
                stroke-width="2"
            ></path>
            <path
                d="M8 14C8.91221 15.2144 10.3645 16 12.0004 16C13.6362 16 15.0885 15.2144 16.0007 14"
                :stroke="color"
                stroke-width="2"
                stroke-linecap="round"
            ></path>
            <path
                d="M9 10.0112V10"
                :stroke="color"
                stroke-width="2"
                stroke-linecap="round"
            ></path>
            <path
                d="M15 10.0112V10"
                :stroke="color"
                stroke-width="2"
                stroke-linecap="round"
            ></path>
        </g>
    </svg>
</template>
<script>
    export default {
        props: {
            size: { type: [String, Number], default: 22 },
            color: { type: String, default: 'white' }
        }
    }
</script>
